module.exports = __webpack_public_path__ + "img/31.6.CODm.ad0c988d.png";